<template>
  <div
    @contextmenu.prevent
    class="iframe-container"
    style="display: flex; flex-direction: column; justify-content: center; align-items: center;"
  >
    <iframe
      :src="iframeUrl"
      style="
        border: 0;
        height: 37rem;
        width: 310px;
      "
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  name: 'CreativeModalAddInfeed',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    mainImageUrl: {
      type: String,
      default: '',
    },
    iconImageUrl: {
      type: String,
      default: '',
    },
    sponsoredBy: {
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: '',
    },
    lpUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      debouncedIframeUrl: '',
    }
  },
  computed: {
    iframeUrl() {
      return this.debouncedIframeUrl
    },
  },
  watch: {
    // プロパティのいずれかが変化した際にdebounce関数を使ってURLを更新
    title: 'updateIframeUrl',
    description: 'updateIframeUrl',
    mainImageUrl: 'updateIframeUrl',
    iconImageUrl: 'updateIframeUrl',
    sponsoredBy: 'updateIframeUrl',
    cta: 'updateIframeUrl',
    lpUrl: 'updateIframeUrl',
  },
  created() {
    this.debouncedIframeUrl = this.generateIframeUrl()
  },
  methods: {
    generateIframeUrl() {
      const baseUrl =
        process.env.NODE_ENV === 'production'
          ? 'https://creative-preview.geo-logic.jp'
          : 'https://creative-preview-dev.geo-logic.jp'

      const queryParams = {
        title: this.title,
        description: this.description,
        mainAssetUrl: this.mainImageUrl,
        iconAssetUrl: this.iconImageUrl,
        sponsored: this.sponsoredBy,
        cta: this.cta,
        lpUrl: this.lpUrl,
      }

      const queryString = Object.entries(queryParams)
        .filter(([, value]) => value)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
        )
        .join('&')

      return `${baseUrl}?${queryString}`
    },
    updateIframeUrl: debounce(function() {
      this.debouncedIframeUrl = this.generateIframeUrl()
    }, 200),
  },
}
</script>

<style scoped lang="scss">
.iframe-container {
  position: relative;
}

.wrapper {
  border: 1px dotted #666;
  height: 100px;
  transition: height 0.5s linear;
}

p {
  margin-top: 17px;
  padding-left: 20px;
}

.error-message {
  position: relative;
  top: -17px;
  color: red;
  font-size: 12px;
}

.errorStringCount {
  color: red;
}
</style>
